export default function Testimonials() {
  const testimonials = [
    {
      name: 'Ahmed Al-Rashid',
      company: 'Dubai Trading Co.',
      location: 'UAE',
      rating: 5,
      text: 'Excellent quality rice and spices. The packaging was perfect and delivery was on time. Mavani globle has become our trusted supplier for bulk orders.',
      avatar: 'https://public.readdy.ai/ai/img_res/c15ecc6827fe713047e60a1a71c2f545.jpg'
    },
    {
      name: 'Sarah Johnson',
      company: 'Global Foods Ltd',
      location: 'United Kingdom',
      rating: 5,
      text: 'Professional service from start to finish. The export documentation was handled smoothly and the product quality exceeded our expectations. Highly recommended!',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20caucasian%20businesswoman%20in%20formal%20attire%20smiling%20warmly%20against%20clean%20minimal%20background%20corporate%20headshot%20style&width=200&height=200&seq=test2&orientation=squarish'
    },
    {
      name: 'Chen Wei',
      company: 'Asia Pacific Imports',
      location: 'Singapore',
      rating: 5,
      text: 'Reliable partner for our spice requirements. Consistent quality, competitive pricing, and excellent communication throughout the entire process.',
      avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20in%20formal%20attire%20smiling%20confidently%20against%20clean%20minimal%20background%20corporate%20headshot%20style&width=200&height=200&seq=test3&orientation=squarish'
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Client <strong className="text-teal-600">Testimonials</strong>
          </h2>
          <div className="w-24 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            What our international clients say about us
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100"
            >
              <div className="flex items-center mb-6">
                <div className="w-16 h-16">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
                <div className="ml-4">
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.company}</p>
                  <p className="text-xs text-gray-500">{testimonial.location}</p>
                </div>
              </div>

              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-lg"></i>
                ))}
              </div>

              <p className="text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
